import { sourceContext } from "aurelia-binding";
var DirtyBindingBehavior = /** @class */ (function () {
    function DirtyBindingBehavior() {
    }
    DirtyBindingBehavior.prototype.bind = function (binding, source, frequency) {
        if (frequency === void 0) { frequency = 500; }
        if (!binding.updateTarget) {
            throw new Error("Only property bindings and string interpolation bindings can be dirty checked.  Trigger, delegate and call bindings cannot be dirty checked.");
        }
        if (frequency) {
            binding.dirtyTimer = setInterval(function (t) { return binding.call(sourceContext); }, frequency);
        }
    };
    DirtyBindingBehavior.prototype.unbind = function (binding, source) {
        if (binding.dirtyTimer) {
            clearInterval(binding.dirtyTimer);
        }
    };
    return DirtyBindingBehavior;
}());
export { DirtyBindingBehavior };
